export const FILE_UPDATED = 'Updated';
export const FILE_REMOVED = 'Removed';

export interface FileUrlResponse {
  url: string;
}

export interface FileUploaded {
  id: string;
  url: string;
}

export enum FileTypeImage {
  JPEG = 'jpeg',
  JPG = 'jpg',
  PNG = 'png',
  SVG = 'svg',
  GIF = 'gif'
}

export enum FileTypeDocument {
  DOC = 'doc',
  DOCX = 'docx',
  ODT = 'odt',
  PDF = 'pdf',
  TXT = 'txt'
}

export enum FileTypePresentation {
  PPS = 'pps',
  PPT = 'ppt',
  PPTX = 'pptx'
}

export enum FileTypeZip {
  ZIP = 'zip'
}

export enum FileTypeExcel {
  XLSX = 'xlsx'
}
